// this code is to find a new sort_order value for the item
// it takes in the item, the direction it needs to be moved
// and the array of items it is a part of
// There are several assumptions that are made
// 1. all items will have an id
// 2. all items will have a sort_order key

import {
  last as Rlast,
  findIndex as RfindIndex,
  propEq as RpropEq,
} from "ramda";

const newSortOrderValue = (item, direction, itemsArray) => {
  const STEP_SIZE = 200;
  let result = {
    noChangeNeeded: false,
    newSortOrder: 200,
  };

  const itemIndex = RfindIndex(RpropEq("id", item.id), itemsArray);

  // find where the item is in the array
  if (direction === "up") {
    if (itemIndex === 0) {
      // nothing to do, the item is fine
      result.noChangeNeeded = true;
      result.newSortOrder = item.sort_order;
    } else if (itemIndex === 1) {
      // second item in the list, get the first one
      // and go half of the sort order
      result.newSortOrder = Math.floor(itemsArray[0].sort_order / 2);
      result.noChangeNeeded = false;
    } else {
      // find the item before it
      const p1Item = itemsArray[itemIndex - 1];
      const p2Item = itemsArray[itemIndex - 2];
      result.newSortOrder = Math.floor(
        (p1Item.sort_order + p2Item.sort_order) / 2,
      );
      result.noChangeNeeded = false;
    }
  } else {
    // move the item down
    const lastIndex = itemsArray.length - 1;
    if (itemIndex === lastIndex) {
      // nothing to do
      result.noChangeNeeded = true;
      result.newSortOrder = item.sort_order;
    } else if (itemIndex === lastIndex - 1) {
      // second to the last item
      // get the last one and add the step size
      const lastItem = Rlast(itemsArray);
      result.noChangeNeeded = false;
      result.newSortOrder = Math.floor(lastItem.sort_order + STEP_SIZE);
    } else {
      const n1Item = itemsArray[itemIndex + 1];
      const n2Item = itemsArray[itemIndex + 2];
      result.noChangeNeeded = false;
      result.newSortOrder = Math.floor(
        (n1Item.sort_order + n2Item.sort_order) / 2,
      );
    }
  }

  return result;
};

export { newSortOrderValue };
